<template>
    <div>
        <div v-for="(item, index) in defaultQuestion" :key="'table1' + index">
            <el-table :data="item.value" style="width: 100%;margin-top: 15px;margin-bottom: 35px;"
                :dimensionName="item.name">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <div class="props-div">
                            <el-checkbox-group v-model="props.row.checkList">
                                <el-checkbox v-for="(ite, ind) in props.row.value" :key="'check' + ind" :label="ite.id"
                                    :disabled="ite.submitStatus == 1">
                                    <div class="p-d-item">
                                        <p class="p-d-i-p">{{ ite.fourthIndicatorName }} <span class="p-d-i-s">{{
                                            ite.classify }}</span></p>
                                    </div>
                                </el-checkbox>
                            </el-checkbox-group>
                            <el-button type="primary" :disabled="props.row.checkList.length == 0 || props.row.status == 4"
                                @click="distribution(props.row.checkList)" style="margin-right: 20px;">分配部门</el-button>
                            <el-checkbox @change="allCheck($event, index, props.$index)" v-model="props.row.allChecked"
                                :disabled="defaultQuestion.length === 0 || props.row.status == 4">全选</el-checkbox>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="item.name" prop="name">
                </el-table-column>
                <el-table-column label="操作" prop="desc">
                    <template slot-scope="scope">
                        <div>
                            <el-button style="margin-left: 0px;" v-show="scope.row.status === 4"
                                @click="toViewQuestions(scope.row.name, 1, item.value.length, scope.$index + 1, item.name)">查看</el-button>
                            <el-button style="margin-left: 0px;" type="primary"
                                v-show="scope.row.status === 1 || scope.row.status === 2 || scope.row.status === 3"
                                @click="toTest(scope.row.name, 1, item.value.length, scope.$index + 1, item.name)">填写</el-button>
                            <el-button style="margin-left: 5px;" v-show="scope.row.status === 3"
                                @click="submitQuestions(scope.row.value)">提交</el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="进度" prop="total">
                    <template slot-scope="scope">
                        <div class="table-progress">
                            <div class="table-progress-item">
                                <el-progress :percentage="(scope.row.progress / scope.row.total) * 100"
                                    :show-text="false"></el-progress>
                            </div>
                            <span class="table-progress-span">{{ scope.row.progress + '/' + scope.row.total
                            }}</span>
                        </div>

                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="name">
                    <template slot-scope="scope">
                        <span>{{ scope.row.status | statusFilter }}</span>
                    </template>
                </el-table-column>

            </el-table>
        </div>
    </div>
</template>
<script>
import { autoFormApi } from '../../api/api-url/autoForm'
export default {
    name: 'IndexQuestions',
    props: {
        questionsList: Array,
        infoId: Number
    },
    data() {
        return {
            defaultQuestion: [],//按指标分类
        }
    },
    watch: {
        questionsList(news) {
            this.defaultQuestion = news
        }
    },
    mounted() {

    },
    filters: {
        statusFilter(val) {
            switch (val) {
                case 1:
                    return '未编辑'
                case 2:
                    return '编辑中'
                case 3:
                    return '待提交'
                case 4:
                    return '已提交'
            }
        }
    },
    methods: {
        //去答题页面
        toTest(name, type, qusLength, qusIndex, dName) {
            // console.log(name, type, qusLength, qusIndex);
            const subName = dName.substr(0, 2)
            this.$router.push({
                name: 'TestPage',
                query: {
                    infoId: this.infoId,
                    name,
                    type,
                    qusLength,
                    qusIndex,
                    dimensionName: subName
                }
            });
        },
        //去查看题目页面
        toViewQuestions(name, type, qusLength, qusIndex, dName) {
            const subName = dName.substr(0, 2)
            this.$router.push({
                name: 'ViewQuestionsPage',
                query: {
                    infoId: this.infoId,
                    name,
                    type,
                    qusLength,
                    qusIndex,
                    dimensionName: subName
                }
            });
        },
        async submitQuestionsApi(str) {
            let res = await autoFormApi.selectSubmit({
                questionIdList: str
            })
            if (res) {
                this.updateData()
            }
        },
        submitQuestions(list) {
            console.log(list);
            let list2 = []
            for (const i in list) {
                list2.push(list[i].id)
            }
            const str = list2.join(',')
            console.log(str);
            this.$confirm('确定提交?', '提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.submitQuestionsApi(str)
                this.$message({
                    type: 'success',
                    message: `提交成功`
                });
            }).catch((action) => {
                if (action === 'cancel') {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                }
            });
        },
        updateData() {
            this.$emit('dataUpdated')
        },
        //分配部门
        distribution(arr) {
            this.$emit('distribution', arr)
        },
        allCheck(val, index, ind) {
            this.$emit('allCheck1', val, index, ind)
        }
    }
}
</script>
<style lang="scss" scoped>
.props-div {
    // height: 200px;
    // background-color: red;
    padding-left: 20px;

    .el-checkbox-group {
        .el-checkbox {
            display: block;
            position: relative;
            margin: 5px 0;

            .p-d-item {
                .p-d-i-p {
                    .p-d-i-s {
                        position: absolute;
                        right: 5%;
                        top: center;
                        color: #3B9395;
                        width: 100px;
                    }
                }
            }
        }
    }
}

.table-progress {
    .table-progress-item {
        width: calc(100% - 62px);
        display: inline-block;
    }

    .table-progress-span {
        width: 50px;
        margin-left: 10px;
        display: inline-block;
    }
}
</style>